//Import REACT components
import React, { Component } from 'react';

//Import admin on rest components
import { GET_LIST } from 'admin-on-rest';

//import custom rest client
import restClient from '../restClient';
import { Card, CardText } from 'material-ui/Card';
//import customerslist component
import DomainsSelector from './Domainsselector';

const styles = {
    flex: { display: 'flex', marginBottom: '1em' },
    leftCol: { flex: 1, marginRight: '1em' },
    rightCol: { flex: 1, marginLeft: '1em' },
    singleCol: { marginTop: '2em' },
	h1: {marginTop: '0', color: '#284263' },
	descriptionCard: {marginBottom: '25px' },
	a : {color: '#284263' },
	ol: {paddingLeft: '15px', lineHeight: '25px', fontSize: '110%' },
	cardText: { color: '#555', lineHeight: '23px', padding: '20px 20px 5px 20px' }
};

class Createads extends Component {
   state = {};

   componentDidMount() {
        const d = new Date();
        d.setDate(d.getDate() - 30);
        
		//request data and store in state
        restClient(GET_LIST, 'member/possibleads', {
                filter: { },
                sort: { },
                pagination: { page: 1, perPage: 100 },
            })
            .then(response => response.data)
            .then(domainsList => {
                this.setState({ domainsList });
            })
	
    }
	
	//render component
    render() {
		const {
            domainsList,
        } = this.state;
       	//component HTML
		return (
         <div>
		 	 <Card style={styles.descriptionCard}>
			 	<CardText style={styles.cardText}>
					<h1 style={styles.h1}>Hoe werkt het?</h1>
					<p>
						<ol style={styles.ol}>
							<li>Kies de voor u relevante sites hieronder en klik op 'Advertentie toevoegen' voor de sites waar u op wilt adverteren.</li>
							<li>Ga naar het menu <strong><a style={styles.a} href="/#/member/ads">mijn advertenties</a></strong> voor een overzicht van uw plaatsingen.</li>
							<li>Stel uw bieding per klik (CPC) in. Hoe hoger de CPC hoe hoger u op de website komt te staan. </li>
							<li>Na goedkeuring en plaatsing op onze vergelijkingssites krijgt u bericht en zal uw advertentie actief worden. </li>
							<li>Zodra een bezoeker naar uw website gaat wordt een klik in rekening gebracht. </li>
							<li>De kliks worden aan het begin van iedere maand gefactureerd over voorgaande maand. </li>
						</ol>
					</p>  
			   </CardText>
			 </Card>
		   	<DomainsSelector nb='Recent ontvangen reviews' domains={domainsList} />
         </div>
          
        );
    }
}

export default Createads;



// WEBPACK FOOTER //
// ./src/admin_ads/Createads.js